import { render, staticRenderFns } from "./EndorsementTopic.vue?vue&type=template&id=977c8368"
import script from "./EndorsementTopic.vue?vue&type=script&lang=js"
export * from "./EndorsementTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports